export default "__VITE_ASSET__CQoPX3eV__"